import { render, staticRenderFns } from "./Server_Component.vue?vue&type=template&id=82956bd4&scoped=true&"
import script from "./Server_Component.vue?vue&type=script&lang=js&"
export * from "./Server_Component.vue?vue&type=script&lang=js&"
import style0 from "./Server_Component.vue?vue&type=style&index=0&id=82956bd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82956bd4",
  null
  
)

export default component.exports